module.exports = __webpack_public_path__ + "img/BannerNewMobile.10aaef84.png";